import React from "react";
import { SvgIconHandler } from "../../../../components/atoms/SvgIconHandler";

import "./slider-arrow-button.m.css";

export const SliderArrowButton = ({ type = "right-arrow" }) => {
  return (
    <div styleName="arrow-button">
      <SvgIconHandler type={type} width={24} height={24} viewBox="0 0 24 24" />
    </div>
  );
};
